import React, {
  forwardRef, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';
import ModalStandalone from '../../lib/ModalStandalone';
import Loader from '../Loader';
import styles from './add-picture-to-document-modal.module.scss';

const TASK_TYPE_OPTIONS = [
  { value: 'HS', label: 'HS' },
  { value: 'Préparation', label: 'Préparation' },
  { value: 'Chargement', label: 'Chargement' },
  { value: 'Déchargement', label: 'Déchargement' },
  { value: 'Retour', label: 'Retour' },
];

const AddPictureToDocumentModal = forwardRef(({
  documentNumber,
  onSubmit,
}, ref) => {
  const [file, setFile] = useState(null);
  const [taskType, setTaskType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const canSubmit = useMemo(() => (
    !!file && !!taskType && !isSubmitting
  ), [file, taskType, isSubmitting]);

  const submitLabel = useMemo(() => (
    documentNumber ? `Ajouter sur ${documentNumber}` : 'Ajouter'
  ), [documentNumber]);

  async function handleSubmit() {
    if (!canSubmit) return;
    setIsSubmitting(true);
    try {
      await onSubmit({ file, taskType });
      ref?.current?.close?.();
      setFile(null);
      setTaskType('');
    } finally {
      setIsSubmitting(false);
    }
  }

  function handleClose() {
    setFile(null);
    setTaskType('');
    setIsSubmitting(false);
  }

  return (
    <ModalStandalone ref={ref} handleClose={handleClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h1>Ajouter une photo</h1>
        {documentNumber && (
          <div className={styles.subTitle}>
            <p>Document: <b>{documentNumber}</b></p>
          </div>
        )}

        <div className={styles.field}>
          <label htmlFor="add-picture-file">Fichier</label>
          <input
            id="add-picture-file"
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
          />
        </div>

        <div className={styles.field}>
          <label htmlFor="add-picture-tasktype">Type de photo</label>
          <select
            id="add-picture-tasktype"
            value={taskType}
            onChange={(e) => setTaskType(e.target.value)}
          >
            <option value="" disabled>Sélectionner…</option>
            {TASK_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        <div className={styles.actions}>
          <button type="button" disabled={!canSubmit} onClick={handleSubmit}>
            {isSubmitting ? <Loader size={16} /> : <span>{submitLabel}</span>}
          </button>
        </div>
      </div>
    </ModalStandalone>
  );
});

AddPictureToDocumentModal.propTypes = {
  documentNumber: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

AddPictureToDocumentModal.defaultProps = {
  documentNumber: null,
};

export default AddPictureToDocumentModal;
